import axios from "axios";

const prepareData = (data) => ({ global_setting: data });

// Plural Actions
export const GET_GLOBAL_SETTINGS = "get_global_settings";
export const getGlobalSettings = (category) => {
  const url = category
    ? `/global_settings.json?category=${encodeURIComponent(category)}`
    : `/global_settings.json`;
  const request = axios.get(url);
  return {
    type: GET_GLOBAL_SETTINGS,
    payload: request,
  };
};

// Singular Actions
export const GET_GLOBAL_SETTING = "get_global_setting";
export const getGlobalSetting = (id) => {
  const url = `/global_settings/${id}.json`;
  const request = axios.get(url);
  return {
    type: GET_GLOBAL_SETTING,
    payload: request,
  };
};

export const UPDATE_GLOBAL_SETTING = "update_global_setting";
export const updateGlobalSetting = (id, data) => {
  const url = `/global_settings/${id}.json`;
  const request = axios({ method: "patch", url: url, data: prepareData(data) });
  return {
    type: UPDATE_GLOBAL_SETTING,
    payload: request,
  };
};
